import { Component, EventEmitter, Output } from '@angular/core';

/** "Complete your health profile". Figma: IVY-HA 235:14685 (desktop) / 235:14609 (mobile). */
@Component({
  selector: 'app-profile-gate',
  standalone: true,
  template: `
    <div class="flex flex-col items-center gap-9 text-center">
      <div class="flex flex-col gap-[6px] text-lg leading-normal">
        <h2 class="font-bold">Complete your health profile</h2>
        <p class="md:font-bold">IVY needs a few essential health details to personalize your experience and insights.</p>
      </div>
      <button
        type="button"
        class="flex h-[55px] w-full items-center justify-center rounded-full bg-[#2F2A4A] px-9 text-[15px] font-bold uppercase leading-5 tracking-[1.5px] text-white"
        (click)="start.emit()"
      >Complete profile</button>
    </div>
  `
})
export class ProfileGateComponent {
  @Output() start = new EventEmitter<void>();
}
